var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublicaciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.8,2.7H57.1V2.2h-3v0.5C33.7,3.5,17.4,20.3,17.4,40.9v117.8c0,15.2,9.4,28.3,22.8,33.8c3.3,1.7,7.1,2.7,11.1,2.7h2.5   h106.5h0.7v-3h-0.7H53.8c-4.3,0-8.5-0.8-12.3-2.3c-7-3.6-11.8-10.8-11.8-19.2c0-11.9,9.6-21.5,21.5-21.5H161v-2.2h0.8V2.7z    M158.8,5.7v140.4H57.1V5.7H158.8z M26.8,170.6c0,3.8,0.9,7.4,2.4,10.6c-5.5-5.9-8.8-13.9-8.8-22.5V40.9c0-18.9,15-34.4,33.7-35.2   v140.4h-2.8C37.8,146.1,26.8,157.1,26.8,170.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 169.4,
    width: 112.7,
    height: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicaciones);
export default __webpack_public_path__ + "static/media/publicaciones.06ec2dae554f78388daea8d47def776c.svg";
export { ForwardRef as ReactComponent };